import React from 'react';
import { useTranslation } from 'react-i18next';
import './index.css';
import { ICON_TYPE } from 'components/IconComponent/constants';
import { TooltipCC } from 'components/common';
import { MapIconFile } from 'components/common/file';
import IconCancel from 'components/IconComponent/IconCancel';
import { convertNameFile, convertTypeFile, downloadFile } from '../file';

const ItemFile = ({ roomId, file, isFirst, onDeleteFile, isDownload = false }) => {

    const {t} = useTranslation()

    const handleDownloadFile = () => {
        if (isDownload) {
            downloadFile(roomId, file)
        } else return;
    };

    return (
        <div
            onClick={handleDownloadFile}
            className={`item-file-container ${onDeleteFile ? '' : 'no-delete'} ${isFirst ? 'first-item-file' : ''}`}
            style={{ cursor: isDownload ? 'pointer' : 'default' }}
        >
            <MapIconFile type={convertTypeFile(file.name)} />
            <TooltipCC title={isDownload ? t('attachFiles.download') + ' ' + file.name : file.name}>
                <span className="file-name">{convertNameFile(file.name)}</span>
            </TooltipCC>
            {onDeleteFile && (
                <TooltipCC title={t('attachFiles.delete')}>
                    <span className="icon-delete-file" onClick={() => onDeleteFile(file.name, file?.id)}>
                        <IconCancel type={ICON_TYPE.CB002B}/>
                    </span>
                </TooltipCC>
            )}
        </div>
    );
};

export default ItemFile;
